__webpack_require__.p = "https://static.bonjoro.com/60585e4c1b8dd5ed0f526e75d1f2ed216aeb7136/assets/bundle/";